/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_Heading_ItalicInputs */

const et_benefits_heading_italic = /** @type {(inputs: Benefits_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aga`)
};

const en_benefits_heading_italic = /** @type {(inputs: Benefits_Heading_ItalicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`But`)
};

/**
* | output |
* | --- |
* | "But" |
*
* @param {Benefits_Heading_ItalicInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_heading_italic = /** @type {((inputs?: Benefits_Heading_ItalicInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_Heading_ItalicInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_heading_italic(inputs)
	return en_benefits_heading_italic(inputs)
});